"use client";

import cn from "clsx";

import styles from "./EnrollNowSponsoredCertifications.module.scss";
import { getGlobalStateValue } from "@/context/utils";
import { pushToDataLayer } from "@/helpers/gtag";
import { IModalActions, ModalTypes } from "@/types/modal";
import { useModalDispatch } from "@/context/ModalContext";
import { useEffect, useState } from "react";

export default function EnrollNowSponsoredCertifications({ associatedPrograms }) {
  const modalDispatch = useModalDispatch();

  const openRFIForm = () => {

   const countryDetails = localStorage.getItem("countryDetails");

    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalFormSponsoredCourses,
        modalData: { associatedPrograms, CTAName: "ENROLL NOW", countryDetails: JSON.parse(countryDetails) },
      },
    });

    setTimeout(() => {
      pushToDataLayer({
        event: "lead_initiate",
        cta_text: "Enroll Now",
        section_name: "Mobile Footer",
        page_type: getGlobalStateValue("pageType"),
        page_url: location.href,
      });
    }, 2500);
  };

  return (
    <div id="enroll-now-cta" className={cn(styles.root)}>
      <button onClick={openRFIForm} className={styles.enrollNow}>
        ENROLL NOW &#8594;
      </button>
    </div>
  );
}
